// extracted by mini-css-extract-plugin
export var externalLink = "_8l-0";
export var internalLinkLabel = "_8l-1";